import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {find} from 'lodash';
import * as qs from "app/lib/helperjs";

export const SelectTarget = ({id, value, options, onClick}) => {
    const getCurrentOption = find(options, (option) => option.props.value === value);

    useEffect(squareFlagIcon);

    return (
        <div className="select-target" onClick={onClick} data-select-target={id}>
            <div className="option">
                {getCurrentOption}
            </div>
            <div className="select-angle-container">
                <i className="fas fa-angle-up select-angle select-angle-up"/>
                <i className="fas fa-angle-down select-angle select-angle-down"/>
            </div>
        </div>
    )
};

/** @private */
const squareFlagIcon = () => {
    const elements = qs.querySelectorAll('.select-target .flag-icon');
    const flagSquaredClass = 'flag-icon-squared';

    elements.forEach((flag) => {
        if (!flag.classList.contains(flagSquaredClass)) {
            flag.classList.add(flagSquaredClass);
        }
    })
};

SelectTarget.propTypes = () => ({
    id: PropTypes.string,
    value: PropTypes.string,
    options: PropTypes.array,
    onClick: PropTypes.func,
});
